import o from"@emotion/cache";var e=o,r=e.default||e;export{r as createCache};
//# sourceMappingURL=createCache.js.map
